import { SlideConfig } from '../types';
import { SIZE_OPTIONS } from './valuation';

export const SLIDE_TO_BENEFIT_KEY: Record<string, string> = {};

export const SLIDES_CONFIG: SlideConfig[] = [
  {
    id: 'location_form',
    type: 'FORM_INPUT',
    title: 'Inserisci il tuo CAP',
    inputs: [
      {
        name: 'zip',
        placeholder: '',
        type: 'tel',
        required: true,
        pattern: '^\\d{5}$',
        maxLength: 5,
      },
    ],
  },
  {
    id: 'boiler_type',
    type: 'SINGLE_ANSWER',
    title: 'Che caldaia hai',
    apiFieldName: 'boiler_type',
    autoAdvance: true,
    answers: [
      { label: 'Gas/Metano', value: 'gas' },
      { label: 'GPL', value: 'gpl' },
      { label: 'Gasolio/Kerosene', value: 'gasolio' },
      { label: 'Altro', value: 'altro' },
    ],
  },
  {
    id: 'install_timeline',
    type: 'SINGLE_ANSWER',
    title: 'Entro quando vorresti sostituirla',
    apiFieldName: 'purchase_time',
    autoAdvance: true,
    answers: [
      { label: 'Entro 1–2 mesi', value: 'one_to_two_months' },
      { label: 'Entro 3–4 mesi', value: 'three_to_four_months' },
      { label: 'Fra 5+ mesi', value: 'more_than_5_months' },
      { label: 'Non ho una scadenza precisa', value: 'dont_know' },
    ],
  },
  {
    id: 'heating_system',
    type: 'SINGLE_ANSWER',
    title: 'Come riscaldi casa?',
    apiFieldName: 'heating_system',
    autoAdvance: true,
    answers: [
      { label: 'Termosifoni', value: 'termosifoni' },
      { label: 'Pavimento', value: 'pavimento' },
      { label: 'Fancoil', value: 'ventole' },
    ],
  },
  {
    id: 'house_size',
    type: 'SINGLE_ANSWER',
    title: 'Quanto è grande la tua casa',
    apiFieldName: 'house_squared_meters',
    autoAdvance: true,
    answers: SIZE_OPTIONS.map((option) => ({
      label: option.label,
      value: option.value,
    })),
  },
  {
    id: 'fotovoltaico',
    type: 'SINGLE_ANSWER',
    title: 'Vuoi il fotovoltaico?',
    apiFieldName: 'fotovoltaico',
    autoAdvance: true,
    answers: [
      { label: 'Sì', value: 'si' },
      { label: 'No', value: 'no' },
      { label: "Ce l'ho già", value: 'gia_installato' },
    ],
  },
  {
    id: 'payout',
    type: 'SINGLE_ANSWER',
    title: "Come vuoi ricevere l'importo?",
    apiFieldName: 'payout',
    autoAdvance: true,
    answers: [
      {
        label: 'Permuta la mia caldaia',
        value: 'trade',
        description: 'Sconto in fattura sulla tua nuova pompa di calore',
        badge: 'Consigliato',
        badges: ['subito in fattura', 'pratiche a carico nostro', 'importo garantito'],
        badgeTone: 'green',
      },
      {
        label: "Richiedi tu l'incentivo al GSE",
        value: 'wire',
        description: "Viene stabilito dopo la verifica dall'ente",
        badges: ['2 rate annuali', 'pratiche a carico tuo', 'importo non garantito'],
        badgeTone: 'gray',
      },
    ],
  },
  {
    id: 'name_form',
    type: 'FORM_INPUT',
    title: 'Inserisci il nome',
    inputs: [
      {
        name: 'name',
        placeholder: '',
        type: 'text',
        required: true,
      },
    ],
  },
  {
    id: 'email_form',
    type: 'FORM_INPUT',
    title: 'Inserisci la tua email',
    inputs: [
      {
        name: 'email',
        placeholder: '',
        type: 'email',
        required: true,
      },
    ],
  },
  {
    id: 'phone_form',
    type: 'FORM_INPUT',
    title: 'Inserisci il numero di telefono',
    inputs: [
      {
        name: 'phone',
        placeholder: '',
        type: 'tel',
        required: true,
      },
    ],
  },
  {
    id: 'loading',
    type: 'INFO',
    title: 'Invio della richiesta in corso...',
  },
  {
    id: 'success',
    type: 'INFO',
    title: 'Le tue preferenze',
  },
  {
    id: 'error',
    type: 'INFO',
    title: 'Qualcosa è andato storto',
  },
];

export const PROGRESS_SLIDE_IDS = SLIDES_CONFIG
  .filter((slide) => slide.type === 'SINGLE_ANSWER' || slide.type === 'FORM_INPUT')
  .map((slide) => slide.id);

export function getBenefitKeyForSlide(slideId: string): string {
  return SLIDE_TO_BENEFIT_KEY[slideId] || slideId;
}

export function getBenefitShortName(benefitText: string | null): string {
  if (!benefitText) return 'il prossimo Beneficio';
  return benefitText;
}
